export const iconStyles = {
  fontSize: {
    xxl: '1.5rem', xl: '1.2rem', lg: '1rem', md: '1rem',
  },
};
